import { TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { styled } from '@mui/material/styles';

const StyledHeaderCell = styled(TableHeaderRow.Cell)(({ theme }) => ({
  padding: `${theme.spacing(1.75)} ${theme.spacing(2)} !important`,
  color: theme.palette.text.secondary,
  ...theme.typography.label,
  '& b': {
    fontWeight: theme.typography.label.fontWeight
  }
}));

export const HeaderCell = props => {
  const { style: propsStyle, ...restProps } = props;
  return (
    <StyledHeaderCell data-nr-col={props?.column?.name} data-testid="grid-header-cell" {...restProps} style={propsStyle}>
      {props.children}
    </StyledHeaderCell>
  );
};
